import { t } from '@i18n';
import { formatDate } from '@utils';
import { PendingCustomer } from '../data/useGetPendingCustomers';

type DetailItem = {
  label: string;
  getText: (customer: PendingCustomer, provinceName?: string) => string | null | undefined;
};

/**
 * Company fields for pending customer detail
 */
export const COMPANY_ITEMS: DetailItem[] = [
  {
    label: 'COMMON:COMPANY_NAME',
    getText: (customer) => customer.customerName,
  },
  {
    label: 'COMMON:CUIT',
    getText: (customer) => customer.cuit,
  },
  {
    label: 'COMMON:SEGMENT',
    getText: (customer) => customer.companyKey,
  },
  {
    label: 'COMMON:CUSTOMER_TYPE',
    getText: (customer) =>
      customer.customerType ? t(`CLIENTS:DETAIL:${customer.customerType}`) : null,
  },
  {
    label: 'COMMON:COMPANY_GROUP',
    getText: (customer) => customer.customerGroup?.name,
  },
  {
    label: 'COMMON:STATUS',
    getText: (customer) =>
      customer.status ? t(`PENDING_CUSTOMERS:STATUS:${customer.status}`) : null,
  },
  {
    label: 'COMMON:CREATED_BY',
    getText: (customer) => customer.createdBy,
  },
  {
    label: 'COMMON:CREATED_AT',
    getText: (customer) => (customer.createdAt ? formatDate(customer.createdAt) : null),
  },
  {
    label: 'PENDING_CUSTOMERS:RESOLVED_BY',
    getText: (customer) => customer.resolvedBy,
  },
  {
    label: 'PENDING_CUSTOMERS:RESOLVED_AT',
    getText: (customer) => (customer.resolvedAt ? formatDate(customer.resolvedAt) : null),
  },
];

/**
 * Address fields for pending customer detail
 */
export const ADDRESS_ITEMS: DetailItem[] = [
  {
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:STREET',
    getText: (customer) => customer.address?.street,
  },
  {
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:NUMBER',
    getText: (customer) => customer.address?.number,
  },
  {
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:FLOOR',
    getText: (customer) => customer.address?.floor,
  },
  {
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:APARMENT',
    getText: (customer) => customer.address?.apartment,
  },
  {
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:CITY',
    getText: (customer) => customer.address?.city?.cityName || customer.address?.city?.cityId,
  },
  {
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:STATE',
    getText: (_customer, provinceName) => provinceName,
  },
  {
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:POSTAL_CODE',
    getText: (customer) => customer.address?.postalCode,
  },
];
